const env = {
  apiUrl: process.env.REACT_APP_API_URL,
  env: process.env.REACT_APP_ENV,
  company: process.env.REACT_APP_COMPANY,
  country: process.env.REACT_APP_COUNTRY,
  bcBaseUrl: process.env.REACT_APP_BC_URL
};

export default env;